import { LanguageDirection, LanguagesCodes } from 'utils/enums/language';

export type IAnyTranslationObject = {
  [key: string]: string | IAnyTranslationObject;
};

export type IFormTablePage = IAnyTranslationObject & {
  table: {
    header: IAnyTranslationObject & {
      actions?: {
        [actionName: string]: IAnyTranslationObject;
      };
    };
    footer: IAnyTranslationObject;
  };
  form: {
    sections: {
      [section: string]: {
        header?: string;
        labels: {
          [field: string]: string;
        };
        validations: {
          [field: string]: string;
        };
      };
    };
    create: {
      submitSuccess?: {
        default: string;
        [type: string]: string;
      };
      submitErrors?: {
        default: string;
        [type: string]: string;
      };
    };
    edit: {
      submitSuccess?: {
        default: string;
        [type: string]: string;
      };
      submitErrors?: {
        default: string;
        [type: string]: string;
      };
    };
  };
};

export const LocaleDirectionMap: Record<LanguagesCodes, LanguageDirection> = {
  [LanguagesCodes.En]: LanguageDirection.LTR,
  [LanguagesCodes.Es]: LanguageDirection.LTR,
  [LanguagesCodes.Pr]: LanguageDirection.LTR,
  [LanguagesCodes.He]: LanguageDirection.RTL,
  [LanguagesCodes.De]: LanguageDirection.LTR,
};
